 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		5: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"7a60f4b61de65ed00ac7208b9c2d1291d7a57158","2":"e8b2b766da704c682c48586e37d0ff56a41d29b8","3":"57a199a45e6870c974941207b3857d633728cbb9","4":"09a231dfebfca290ff0d3add30f44d3cf6696be4","7":"component---src-pages-404-js","8":"component---src-pages-aktualnosci-js","9":"component---src-pages-index-js","10":"component---src-pages-kontakt-js","11":"component---src-pages-o-nas-js","12":"component---src-pages-podopieczni-js","13":"component---src-pages-uslugi-js","14":"component---src-pages-wesprzyj-nas-js","15":"component---src-pages-wydarzenia-akcja-mikolajkowa-2022-js","16":"component---src-pages-wydarzenia-akcja-podaruj-dzieciom-ksiazke-js","17":"component---src-pages-wydarzenia-alternatywne-formy-wsparcia-js","18":"component---src-pages-wydarzenia-aplikacja-fani-mani-js","19":"component---src-pages-wydarzenia-charytatywny-bieg-piatka-dla-fundacji-js","20":"component---src-pages-wydarzenia-final-akcji-mikolaj-2021-js","21":"component---src-pages-wydarzenia-final-akcji-mikolaj-2022-js","22":"component---src-pages-wydarzenia-fundacja-x-fosa-js","23":"component---src-pages-wydarzenia-koledowanie-2022-js","24":"component---src-pages-wydarzenia-kurs-prawa-jazdy-oli-js","25":"component---src-pages-wydarzenia-licytacja-charytatywna-js","26":"component---src-pages-wydarzenia-licytacje-charytatywne-js","27":"component---src-pages-wydarzenia-listy-do-swietego-mikolaja-js","28":"component---src-pages-wydarzenia-makramy-js","29":"component---src-pages-wydarzenia-mikolajki-2020-js","30":"component---src-pages-wydarzenia-mikolajki-2021-js","31":"component---src-pages-wydarzenia-nasz-zespol-js","32":"component---src-pages-wydarzenia-nasza-fundacja-js","33":"component---src-pages-wydarzenia-nasze-cele-na-rok-2022-js","34":"component---src-pages-wydarzenia-nasze-fundacyjne-projekty-js","35":"component---src-pages-wydarzenia-nasze-plany-na-2023-js","36":"component---src-pages-wydarzenia-niezly-lumpeks-js","37":"component---src-pages-wydarzenia-nowi-wolontariusze-js","38":"component---src-pages-wydarzenia-nowy-grafik-zajec-js","39":"component---src-pages-wydarzenia-nowy-keyboard-js","40":"component---src-pages-wydarzenia-nowy-rok-js","41":"component---src-pages-wydarzenia-oboz-jezdzicki-dla-podopiecznych-js","42":"component---src-pages-wydarzenia-obozy-konne-dla-naszych-podopiecznych-js","43":"component---src-pages-wydarzenia-obozy-konne-js","44":"component---src-pages-wydarzenia-pierwsze-przejazdzki-i-warsztaty-robienia-pizzy-js","45":"component---src-pages-wydarzenia-pierwszy-turnus-obozow-konnych-js","46":"component---src-pages-wydarzenia-piknik-js","47":"component---src-pages-wydarzenia-piknik-rodzinny-js","48":"component---src-pages-wydarzenia-podsumowanie-2022-js","49":"component---src-pages-wydarzenia-podsumowanie-charytatywnego-biegu-piatka-dla-fundacji-js","50":"component---src-pages-wydarzenia-podsumowanie-obozu-jezdzieckiego-js","51":"component---src-pages-wydarzenia-podsumowanie-pikniku-js","52":"component---src-pages-wydarzenia-podsumowanie-transportu-js","53":"component---src-pages-wydarzenia-podsumowanie-wydarzenia-w-fosie-js","54":"component---src-pages-wydarzenia-podsumowanie-zbiorki-z-polskie-radio-rzeszow-js","55":"component---src-pages-wydarzenia-podziekowania-dla-centrum-inwestycji-deweloperskich-rzeszow-js","56":"component---src-pages-wydarzenia-podziekowania-za-akcje-mikolaj-2021-js","57":"component---src-pages-wydarzenia-polmetek-obozu-jezdzieckiego-juz-za-nami-js","58":"component---src-pages-wydarzenia-pomoc-dla-dzieci-z-ukrainy-js","59":"component---src-pages-wydarzenia-pomoc-dla-obywateli-ukrainy-js","60":"component---src-pages-wydarzenia-pomoc-dla-szpitala-i-sierocinca-w-ukrainie-js","61":"component---src-pages-wydarzenia-radosc-w-centrum-zabaw-fantazja-js","62":"component---src-pages-wydarzenia-rozpoczecie-akcji-mikolaj-2021-js","63":"component---src-pages-wydarzenia-rzeszow-dla-ukrainy-nowy-projekt-js","64":"component---src-pages-wydarzenia-rzeszow-dla-ukrainy-pierwsze-zajecia-js","65":"component---src-pages-wydarzenia-spotkanie-w-firmie-drewpol-js","66":"component---src-pages-wydarzenia-szkolenie-z-wizazu-js","67":"component---src-pages-wydarzenia-szukamy-korepetytorow-js","68":"component---src-pages-wydarzenia-szukamy-wolontariuszy-js","69":"component---src-pages-wydarzenia-ubrania-do-oddania-js","70":"component---src-pages-wydarzenia-wsparcie-od-centrum-inwestycji-deweloperskich-rzeszow-js","71":"component---src-pages-wydarzenia-wspolpraca-z-silownia-coolgym-coolturysta-js","72":"component---src-pages-wydarzenia-wyjscie-do-fly-wall-js","73":"component---src-pages-wydarzenia-wyjsie-do-muzeum-dobranocek-js","74":"component---src-pages-wydarzenia-wywiad-z-vasylem-js","75":"component---src-pages-wydarzenia-zbiorka-dla-ukrainskich-sierocincow-js","76":"component---src-pages-wydarzenia-zbiorka-z-polskie-radio-rzeszow-js","77":"component---src-templates-podopieczni-js"}[chunkId]||chunkId) + "-" + {"0":"6efc440a25ba53e1659d","1":"d57e403f6b3df0c7cfb5","2":"52eac40d94041eb9db96","3":"b9bba2bd1788aae05fff","4":"6791022e05e4f09de548","7":"03b5bb01beb477ee38f8","8":"a7decf6a406831c84a86","9":"bc8e353570437701b507","10":"5c2442e4314c06ef66d6","11":"692016ecb84674c021c2","12":"a38f3c6556cb150ef933","13":"721ff3d037ebe3445c9d","14":"af1f6f1febf80ac1da6b","15":"7e5ef14bd1e7a5ddd39b","16":"6e8ebcf0a5902104a401","17":"b465a1b5cd8ee21715ee","18":"6ef3f07bb2f20ffe30c0","19":"ed3d5b435799336ce687","20":"1f0a6b87648f14d8f323","21":"219242534a74d7e86fd5","22":"c96037339d0d96799d61","23":"6768b1551fc9cbdbc4c9","24":"7b250d88de214d354f80","25":"689bdfbf78c1b7fae83f","26":"30d930e71d1ef1c8c7ab","27":"220fc6ff7cf4ec1affaf","28":"bafc9aae5d8ee4815aa4","29":"cc8dcc4545e2f02073ef","30":"0378ba87e45ae76f6883","31":"0ae2f7d3b470c631bad7","32":"0848e8c12c00a5a98d8b","33":"145f6f5f7081624cec8e","34":"8b1028fa0249eab855d3","35":"5142ea224ed3e2923b2d","36":"091c7b320f520dd21d3b","37":"2e8535bcf032e409de05","38":"a7c71289ca37d4f53fcd","39":"6e1c5e0d751673042e9c","40":"d28acbbd3050e6ac7f95","41":"4e729312a005eb4e2b35","42":"7dc839f9c8fd342b2a1f","43":"4f27817c131f740894a0","44":"fb059de481e70f9b8da6","45":"81b1cdc615fa2555d7c0","46":"26ad87177024914446a3","47":"0a0b7a20020150083133","48":"fff966d3df521d268eb4","49":"c65ba300206176b0e14a","50":"38d63a9c883f6522da1c","51":"8ceb1e093417d9b50d99","52":"9d7dc772c5b81bfb2525","53":"d726400d237c3d44fd33","54":"6f5d1349eaa8db5577c4","55":"091b5b0fbffcf5bb69e6","56":"89ada30a8594d5bbb2a2","57":"95ec6bd3ff531200ae12","58":"f5d2f30407518af8a28e","59":"6b829287f516cc1a7c61","60":"fd3ab39f417068af2799","61":"2c582a701d5fa7b9b2ed","62":"0e434ebc950c514f6ba6","63":"a37a990eb4a66ed67e92","64":"bb3e5cdb7e3ab9f4cbd6","65":"2fb84ebb75c7ea7f59ca","66":"2874876285cc66bc8676","67":"0f01cade0b76bcc3a1c4","68":"4982cd1192821c257219","69":"7e50db02f28028cc8f65","70":"6e10efac3d5e82b71a0b","71":"0dcd38cf78a594177a56","72":"4edbd007118c8697aa39","73":"d5bdb3af9a3f3fceafa2","74":"763a0a08095fbe8cbb84","75":"f657f5b8b6c25498b36c","76":"4b8aba991ebd01b4ee41","77":"20a9291eef8209aeb357"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
